/**
 * The site's public address, for links that leave the page: email redirect
 * targets (password reset, sign-in), share and referral links, and return
 * URLs handed to payment portals.
 *
 * On the web that is the page's own origin (localhost in dev, defera.app in
 * production). Inside the iOS app the page is served from
 * capacitor://localhost, which means nothing outside the app, so links point
 * at defera.app instead.
 */
import { Capacitor } from '@capacitor/core';

export const PUBLIC_SITE_ORIGIN = 'https://defera.app';

export function publicOrigin() {
  if (typeof window === 'undefined') return PUBLIC_SITE_ORIGIN;
  return Capacitor.isNativePlatform() ? PUBLIC_SITE_ORIGIN : window.location.origin;
}
